import styled, { device, color } from '@styled'

export const ServicesWrapper = styled.section`
  padding-block-start: 30px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ul {
    padding-left: 1em;
    li {
      list-style-type: '... ';
    }
  }
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`

export const TitleWrapper = styled.div`
  font-size: 1em;
  margin: 25px 0;
  width: 12px;
  height: 12px;
  border: none;
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  z-index: 1;
  pointer-events: auto;
  background-color: rgb(0 64 138 / 100%);
  color: rgb(20 36 69 / 100%);
  border-radius: 50%;
  box-sizing: border-box;
  transition: padding 0.3s ease;
  pointer-events: none;

  .title-text {
    width: 150px;
    position: absolute;
    text-decoration: underline dotted;
    pointer-events: auto;
    ${device.large} {
      text-decoration: none;
      width: 100%;
      position: relative;
    }
  }

  ${device.large} {
    position: relative;
    font-size: 0.75em;
    margin: 0 3px;
    width: 115px;
    height: 115px;
    background-color: white;
    border: 2px solid rgb(0 64 138 / 100%);
    border-radius: 50%;
    :hover {
      background-color: rgb(0 64 138 / 100%);
      color: white;
    }
    pointer-events: auto;
  }
  ${device.xlarge} {
    font-size: 0.9em;
    margin: 0 5px;
    width: 145px;
    height: 145px;
  }

  ${(props) =>
    (props['data-position'] === 'left' &&
      `
        .title-text {
            left: -160px;
            ${device.large} {
                left: 0;
            }
        }
    `) ||
    (props['data-position'] === 'right' &&
      `
        .title-text {
            right: -160px;
            ${device.large} {
                right: 0;
            }
        }
    `)}

  :hover ~ .subpoints {
    @media (hover: hover) and (pointer: fine) {
      visibility: visible;
      opacity: 1;
    }
  }
`

export const CirclesWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-left: 34px;
  margin-right: 34px;
  margin-block-start: 30px;
  position: relative;
  ::after {
    content: '';
    border-radius: 75%;
    background-color: rgb(0 64 138 / 100%);
    position: absolute;
    height: 100%;
    width: 6px;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    ${device.large} {
      height: 7px;
      width: 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  ${device.large} {
    display: flex;
    flex-direction: row;
  }
`

export const LogoWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 150px;
    padding: 10px;
    margin-top: 50px;
    font-size: 2em;
    ${device.small} {
        width: 190px;
    }
    ${device.medium} {
        width 200px;
    }
    ${device.large} {
        width: 230px;
    }
`

export const Subpoints = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 50%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-top: 12px;
  text-align: left;
  z-index: 2000;
  color: black;
  pointer-events: none;
  transition:
    opacity 0.1s ease-in-out,
    visibility 0.1s ease-in-out;
  font-size: 0.8em;
  width: 200px;

  top: -50%;
  ${(props) =>
    (props['data-position'] === 'left' &&
      `
        transform: translateX(-10%);
    `) ||
    (props['data-position'] === 'right' &&
      `
        transform: translateX(-90%);
    `)}
  ${device.large} {
    top: 100%;
    transform: translateX(-50%);
    font-size: 1em;
    width: 250px;
  }
`
